import type { RowData } from "@tanstack/react-table";
import { flexRender } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

import styles from "../styles.module.scss";

import type { ITableChildProps } from "@components/organisms/table/types";
import { Typography } from "@/components/atoms/typography";

export function Thead<TData extends RowData>({
  tableInstance,
  showRow,
}: ITableChildProps<TData>) {
  const { t } = useTranslation("field");

  return (
    <thead className={styles.thead}>
      {tableInstance?.getHeaderGroups()?.map((headerEl, index) => {
        return (
          // eslint-disable-next-line react/no-array-index-key
          <tr key={`${headerEl.id}index${index}`}>
            {showRow && <th>{t("row")}</th>}
            {headerEl.headers.map((columnEl, index2) => {
              return (
                <th
                  key={
                    // eslint-disable-next-line react/no-array-index-key
                    `${columnEl.id}index2${index2}`
                  }
                  colSpan={columnEl.colSpan}
                  className={styles.th}
                  style={
                    columnEl.getSize() === 150
                      ? undefined
                      : { width: columnEl.getSize() }
                  }
                >
                  <Typography color={"inherit"}>
                    {flexRender(
                      columnEl.column.columnDef.header,
                      columnEl.getContext(),
                    )}
                  </Typography>
                </th>
              );
            })}
          </tr>
        );
      })}
    </thead>
  );
}
